import { useQuery } from '@tanstack/react-query';
import { unwrap } from '@billda/api';
import { useAuthStore } from '../../auth/stores/authStore';
import { api } from '../../../shared/api/billdaApi';
import { dashboardKeys } from './dashboardKeys';

export function useGetOpenPots() {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery({
    queryKey: dashboardKeys.openPots(),
    queryFn: async ({ signal }) =>
      unwrap(
        await api.legacy.GET('/api/v1/dashboard/open-pots', {
          signal,
        })
      ),
    enabled: isAuthenticated,
    staleTime: 30_000,
  });
}
